/** The client build (vite.config.ts `define`), 'dev' when it was not baked in. */
declare const __BH_BUILD__: string | undefined;

export const CLIENT_BUILD: string = typeof __BH_BUILD__ === 'string' && __BH_BUILD__ ? __BH_BUILD__ : 'dev';
